import classnames from 'classnames';

import { labelStyle } from '@/signupElement/Signup.css';
import type { Preference } from '@/signupElement/Signup.types';

import RadioOption from './RadioOption';

interface Props {
  preference: Preference;
}

const BooleanInputs = ({ preference }: Props) => {
  return (
    <fieldset className="flex flex-col gap-2">
      <legend className={classnames('text-left w-full', labelStyle)}>
        {preference?.name}
        {preference?.required && <span>*</span>}
      </legend>
      <div>
        <RadioOption
          name={`field_${preference.custom_field_id}`}
          label="True"
          value="true"
          required={preference?.required}
        />
        <RadioOption name={`field_${preference?.custom_field_id}`} label="False" value="false" />
      </div>
    </fieldset>
  );
};

export default BooleanInputs;
